import { render } from "./ShipmentsInquiryGridItem.vue?vue&type=template&id=f58d2dbc"
import script from "./ShipmentsInquiryGridItem.vue?vue&type=script&lang=js"
export * from "./ShipmentsInquiryGridItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__